import { Box, Container, IconButton, Popper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useCallback, useMemo, useState } from "react";
import useCorClaraOuEscura from "../../lib/useCorClaraOuEscura";
import { colors, TMenuOptions } from "./bannerColors";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { clarearCor } from "../../helpers/manipulacaoCores";
import Menus from "./Menus";
import { ModalStateContextProvider } from "../../contexts/ModalStateContext";
import ModaisFinanceiro from "./Menus/Financeiro/Modais";
import ModaisCadastros from "./Menus/Cadastros/Modais";
import ModaisComercial from "./Menus/Comercial/Modais";
import ModaisEstoque from "./Menus/Estoque/Modais";
import ModaisReceituario from "./Menus/ReceituarioAgronomico/Modais";

export default function ScreenBanner({
    title,
}: ScreenBannerProps) {

    const navigate = useNavigate();
    const color = colors[title] || "#1E2E6B"
    const luminosidade = useCorClaraOuEscura(color)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    //valores importantes
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const corOpaca = clarearCor(color)

    const corDaFonte = useMemo(() => {
        if (luminosidade === "clara") return "black"
        if (luminosidade === "escura") return "white"
    }, [luminosidade])
    //

    //funções manipuladoras
    const handleEnter = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLeave = () => {
        setAnchorEl(null);
    };

    const handleNavigate = useCallback(() => {
        navigate(-1)
    }, [navigate])
    //

    return (
        <ModalStateContextProvider>
            <Box
                width="100%"
                height={60}
                bgcolor={color}
            >
                <Container>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <IconButton
                            size="large"
                            edge="start"
                            sx={{ mr: 2 }}
                            onClick={handleNavigate}
                        >
                            <ArrowBackIcon style={{ color: corDaFonte, fontSize: 36 }} />
                        </IconButton>

                        <Box
                            gap={1}
                            width="100%"
                            textAlign="center"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ cursor: "pointer" }}
                            onMouseEnter={handleEnter}
                            onMouseLeave={handleLeave}
                        >
                            <Typography variant='h5' color={corDaFonte}>{title}</Typography>
                            <KeyboardArrowDownIcon sx={{ color: "white" }} />
                            <Popper
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                placement="bottom-start"
                                sx={{
                                    width: '100%',
                                    boxShadow: "0 2px 2px rgba(0, 0, 0, 0.2)",
                                    position: "relative",
                                    zIndex: 1000 //necessário para ficar acima de label inputs ou header forms
                                }}
                            >
                                <Box
                                    py={2.5}
                                    mt={1.7}
                                    width="100%"
                                    bgcolor={corOpaca}
                                >
                                    <Container>
                                        <Menus type={title} />
                                    </Container>
                                </Box>
                            </Popper>
                        </Box>

                        <Box width={60} />
                    </Box>
                </Container>
            </Box>
            
            <ModaisCadastros/>
            <ModaisFinanceiro/>
            <ModaisComercial/>
            <ModaisEstoque/>
            <ModaisReceituario/>
        </ModalStateContextProvider>
    )
}

interface ScreenBannerProps {
    title: TMenuOptions,
    color?: string
}